import { render, staticRenderFns } from "./CartillaOspetax.vue?vue&type=template&id=c2412352&"
import script from "./CartillaOspetax.vue?vue&type=script&lang=js&"
export * from "./CartillaOspetax.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports